import { render, staticRenderFns } from "./PerformanceItem2021.vue?vue&type=template&id=0afb6b5f&scoped=true&"
import script from "./PerformanceItem2021.vue?vue&type=script&lang=js&"
export * from "./PerformanceItem2021.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceItem2021.vue?vue&type=style&index=0&id=0afb6b5f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afb6b5f",
  null
  
)

export default component.exports